import React, { useState } from "react";
import { Button, Grid, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";

const ARCHIVE_TYPE_OPTIONS = [
  { value: "not_customer", label: "Il cliente ha revocato lo specifico incarico attinente a questo modulo" },
  { value: "end_relationship", label: "Il cliente ha scelto di terminare qualunque rapporto con LEXIA" },
  { value: "not_confirmed", label: "A seguito di nuovo incarico, il cliente non ha confermato i precedenti dati AML ed è dunque necessario raccogliere un nuovo modulo." },
  { value: "manual", label: "Altro" },
];

const MAX_REASON_LENGTH = 100;

const ModalArchivia = ({ onClose, confirm, amlStatus }) => {
  const [archiveType, setArchiveType] = useState("");
  const [reason, setReason] = useState("");
  const [openWarning, setOpenWarning] = useState(false);

  const isValid =
    archiveType !== "" &&
    (archiveType !== "manual" || reason.trim() !== "");

  return (
    <Grid
      container
      item
      xs={11}
      md={7}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "90vh",
        overflowY: "auto",
        width: { xs: "95%", sm: "80%" },
        borderRadius: "16px",
        outline: "none",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* ── Header ── */}
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
          padding: "0 15px",
          gap: "10px",
          flexShrink: 0,
        }}
      >
        <div style={{ flexShrink: 0 }}>
          <div className="icon-modal-archived" />
        </div>
        <Typography
          className="color-blue-dark"
          style={{ flex: 1, minWidth: 0, fontSize: "18px", fontWeight: 600 }}
        >
          Archivia Modulo AML
        </Typography>
        <div style={{ flexShrink: 0 }}>
          <div onClick={onClose} className="icon-modal-close" />
        </div>
      </Grid>

      {/* ── Body ── */}
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 15px",
        }}
      >
        <Typography
          className="color-blue-dark"
          style={{ marginBottom: "20px", fontSize: "16px" }}
        >
          Seleziona il motivo per cui stai archiviando questo modulo
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography className="color-blue-dark title-input">
              Motivo archiviazione
            </Typography>
            <Select
              value={archiveType}
              onChange={(e) => {
                const val = e.target.value;
                setArchiveType(val);
                if (val !== "manual") setReason("");
                if (val === "not_confirmed") setOpenWarning(true);
              }}
              displayEmpty
              fullWidth
              sx={{ mt: 0.5 }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxWidth: { xs: "calc(100vw - 32px)", md: 520 },
                    width: "100%",
                  },
                },
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
              }}
            >
              <MenuItem value="">
                <span style={{ color: "#abb0b6" }}>Seleziona</span>
              </MenuItem>
              {ARCHIVE_TYPE_OPTIONS.filter((opt) =>
                opt.value !== "not_confirmed" || amlStatus === "approved"
              ).map((opt) => (
                <MenuItem
                  key={opt.value}
                  value={opt.value}
                  sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
                >
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>


        {archiveType === "manual" && (
          <>
            <Typography
              className="color-blue-dark title-input"
              style={{ marginTop: "20px" }}
            >
              Motivo speciale
            </Typography>
            <TextField
              placeholder="Inserisci"
              value={reason}
              onChange={(e) => {
                if (e.target.value.length <= MAX_REASON_LENGTH) {
                  setReason(e.target.value);
                }
              }}
              fullWidth
              variant="outlined"
              sx={{ mt: 0.5 }}
              InputProps={{ style: { color: "#1b2838", fontSize: "14px" } }}
            />
            <Typography
              style={{
                fontSize: "12px",
                color: reason.length >= MAX_REASON_LENGTH ? "#d32f2f" : "#888",
                textAlign: "right",
                marginTop: "4px",
              }}
            >
              {reason.length}/{MAX_REASON_LENGTH}
            </Typography>
          </>
        )}
      </Grid>

      {/* ── Warning Modal ── */}
      <Modal open={openWarning} onClose={() => setOpenWarning(false)}>
        <Grid
          container
          item
          xs={10}
          md={4}
          sx={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            borderRadius: "16px",
            outline: "none",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Grid
            item
            xs={12}
            style={{
              height: "60px",
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid #c6c6c6",
              padding: "0 15px",
              gap: "10px",
            }}
          >
            <div style={{ flexShrink: 0 }}>
              <div className="icon-modal-info" />
            </div>
            <Typography className="color-blue-dark" style={{ flex: 1, minWidth: 0, fontSize: "18px", fontWeight: 600 }}>
              Attenzione
            </Typography>
            <div style={{ flexShrink: 0 }}>
              <div onClick={() => setOpenWarning(false)} className="icon-modal-close" />
            </div>
          </Grid>
          <Grid item xs={12} sx={{ px: 2, pt: 2, pb: 1 }}>
            <Typography className="color-blue-dark" style={{ fontSize: "14px" }}>
              ATTENZIONE! Selezionando questo motivo di archiviazione verrà automaticamente avviato un nuovo processo di raccolta dati. Il cliente riceverà un link per la compilazione di un nuovo modulo AML.
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
            <Button
              className="button-bg-purple"
              sx={{ width: "120px" }}
              onClick={() => setOpenWarning(false)}
            >
              <Typography className="color-light" sx={{ textTransform: "initial", fontSize: "16px", fontWeight: 500 }}>
                Chiudi
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Modal>

      {/* ── Footer ── */}
      <Grid container item xs={12}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <Button
            className="button-bg-purple"
            sx={{ width: "140px" }}
            onClick={() => confirm(archiveType, reason)}
            disabled={!isValid}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              Archivia
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalArchivia;
